import Promise from 'bluebird';
import { map, object } from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

import pkg from './package.json';

export { dummyDataSource } from './demo/mock/dummy-data-source';

export function getAdGroupGridFactory(initializeGlobalContext = true) {
  if (initializeGlobalContext) {
    return globalContext.define(
      pkg.legacyDependencies,
      () => import(/* webpackMode: 'eager' */ './src/ad-group-gridview-factory')
    );
  }
  return import(/* webpackMode: 'eager' */ './src/ad-group-gridview-factory'); // eslint-disable-line no-unused-vars
}

const bidLandscapeDependencies = [
  'component/config/index',
  '@bingads-webui/i18n-amd-loader!campaignui/feature/ad-groups-tab',
  'module/service/shared/popup',
  'campaignui/feature/instrumentation/index',
  'component/api-errors-campaign/index',
  'component/js-data-campaign/index',
  'module/service/communication/channel/odata',
];
let adGroupBidLandscapeInitializer = null;

export function getAdGroupBidLandscapeInitializer(initializeGlobalContext = true) {
  if (initializeGlobalContext) {
    const landscapePromise = new Promise((resolve) => {
      if (adGroupBidLandscapeInitializer) {
        resolve(adGroupBidLandscapeInitializer);
      } else {
        window.require(bidLandscapeDependencies, () => {
          const dependecies = object(
            bidLandscapeDependencies,
            map(bidLandscapeDependencies, dep => window.require(dep))
          );

          globalContext.define(
            bidLandscapeDependencies,
            () => import(/* webpackMode: 'eager' */ './src/bid-landscape/index')
          )(dependecies).then((result) => {
            adGroupBidLandscapeInitializer = result;
            resolve(result);
          });
        });
      }
    });
    return landscapePromise;
  }
  return import(/* webpackMode: 'eager' */ './src/bid-landscape/index');
}


let adGroupBidLandscapeInitializerWebpack = null;

export function getAdGroupBidLandscapeInitializerWebpack(
  initializeGlobalContext = true,
  dependecies
) {
  if (initializeGlobalContext) {
    const landscapePromise = new Promise((resolve) => {
      if (adGroupBidLandscapeInitializerWebpack) {
        resolve(adGroupBidLandscapeInitializerWebpack);
      } else {
        globalContext.define(
          bidLandscapeDependencies,
          () => import(/* webpackMode: 'eager' */ './src/bid-landscape/index')
        )(dependecies).then((result) => {
          adGroupBidLandscapeInitializerWebpack = result;
          resolve(result);
        });
      }
    });
    return landscapePromise;
  }
  return import(/* webpackMode: 'eager' */ './src/bid-landscape/index');
}
